export default
function (ngModule) {
    ngModule.directive('twitterDocumentCard', [function(){
        return {
            restrict: 'E',
            template: require('./mw-card.html'),
            controllerAs: 'vm',
            controller: 'TwitterDocumentCardController',
            scope: {
                document: '=?',
                displaySettings: '=',
                documentClick: '&',
                overlaySentiment: '&',
                isNarrowCard: '=',
                showFooter: '=',
                showOpenDocumentIcon: '=',
                isEngagementEnabled: '='
            }
        };
    }])
    .controller('TwitterDocumentCardController', [
        '$scope',
        'translationService',
        'GeoService',
        TwitterDocumentCardController
    ]);

    function TwitterDocumentCardController($scope, translationService, GeoService) {

        this.isEngagementDataVisible = false;
        
        var documentClick = function documentClick(url, event) {
            if(url) {
                return $scope.documentClick({
                    event: event,
                    document: $scope.document,
                    url: url
                });
            }
        };

        var update = function update() {
            var author = ($scope
                && $scope.document
                && $scope.document.authors
                && $scope.document.authors[0])
                || { name: translationService.getLocalizedString('Unknown') };

            var authorName = author.name || translationService.getLocalizedString('Unknown'),
                authorUrl = author.url,
                authorHandle = author.handle || translationService.getLocalizedString('Unknown');

            this.imagesVisible = $scope.displaySettings.images;
            this.avatarsVisible = $scope.displaySettings.avatar;
            this.isNarrowCard = $scope.isNarrowCard;

            this.showFooter = $scope.showFooter;
            this.showOpenDocumentIcon = $scope.showOpenDocumentIcon;

            this.mediaType = $scope.document.mediaType;
            this.mediaTypeIcon = $scope.document.mediaTypeIcon || $scope.document.mediaType;

            this.avatarTitle = authorName;

            if(author.handle) {
              this.avatarImageUrl = author.handle
                ? `https://shuhari-iconoclast-production.herokuapp.com/tweeticon?handle=${author.handle}`
                : undefined;
            }

            this.avatarLinkUrl = authorUrl;

            this.document = $scope.document;
            this.documentId = $scope.document.documentId;
            this.documentUrl = $scope.document.redirectUrl || $scope.document.url;

            this.sourceName = authorName;
            this.sourceUrl = authorUrl;
            this.authors = [{
                name: authorHandle,
                url: authorUrl,
                onClick: documentClick.bind(this, authorUrl)
            }];

            GeoService.convertCountryCodeToCode3($scope.document.country).then(function(countryCode3) {
                this.countryCode = countryCode3;
            }.bind(this));

            this.date = $scope.document.date;

            this.bigText = $scope.displaySettings.hitSentence
                ? [($scope.document.matchSentence || $scope.document.tagContextMatchSentence) || $scope.document.body]
                : [];

            this.tags = ($scope.displaySettings.displayTags && $scope.document.tags) || [];
            this.keywords = ($scope.displaySettings.keywords && $scope.document.keywords) || [];

            this.socialReach = $scope.document.reach;
            this.isEngagementEnabled = $scope.isEngagementEnabled;
            this.isEngagementAvailable = ($scope.document.engagement == null ? false : true);
            this.engagement = $scope.document.engagement;
            if ($scope.document.socialScores) {
                this.engagementData = [
                    {name:"social-engagement--replies", value: $scope.document.socialScores.tw_replies},
                    {name:"social_engagement--retweets", value: $scope.document.socialScores.tw_retweets},
                    {name:"social_engagement--likes", value: $scope.document.socialScores.tw_likes}
                ];
            }
            this.lastUpdateDate = $scope.document.engagementLastUpdateDate;
            this.sentiment = $scope.document.sentiment;
            this.isSentimentModified = $scope.document.isSentimentModified;
            this.originalSentiment = $scope.document.originalSentiment;

            this.onAvatarClick = documentClick.bind(this, authorUrl);
            this.onSourceIconClick = documentClick.bind(this, this.documentUrl);
            this.onSourceNameClick = documentClick.bind(this, this.sourceUrl);
            this.onDocumentOpenClick = documentClick.bind(this, this.documentUrl);

            this.onOverlaySentimentClick = $scope.overlaySentiment;

        }.bind(this);

        this.onEngagementDataClick = function() {
            this.isEngagementDataVisible = !this.isEngagementDataVisible;
        }.bind(this);

        $scope.$watch('displaySettings', update, true);
        $scope.$watch('document', update, true);

        update();
    }

}



// WEBPACK FOOTER //
// ./source/components/document-card/twitter-document-card.js